(function () {
  function ready(callback) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", callback, { once: true });
    } else {
      callback();
    }
  }

  ready(function () {
    var mexicoMarketForm = document.getElementById("RawdotMarketLocalizationForm");
    if (mexicoMarketForm) {
      mexicoMarketForm.submit();
      return;
    }

    var nav = document.querySelector("[data-nav]");
    var hero = document.querySelector(".hero");
    var menuToggle = document.querySelector("[data-menu-toggle]");
    var mobileMenu = document.querySelector("[data-mobile-menu]");
    var lastFocused = null;

    requestAnimationFrame(function () {
      if (hero) hero.classList.add("hero-in");
    });

    if ("IntersectionObserver" in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.15 });
      document.querySelectorAll("[data-reveal], .reveal").forEach(function (element) {
        var delay = element.getAttribute("data-reveal-delay");
        if (delay) element.style.setProperty("--reveal-delay", delay + "ms");
        observer.observe(element);
      });
    } else {
      document.querySelectorAll("[data-reveal], .reveal").forEach(function (element) {
        element.classList.add("is-visible");
      });
    }

    function updateNav() {
      if (nav) nav.classList.toggle("nav-scrolled", window.scrollY > 20);
    }
    updateNav();
    window.addEventListener("scroll", updateNav, { passive: true });

    function closeMenu() {
      if (!mobileMenu || !menuToggle) return;
      mobileMenu.hidden = true;
      menuToggle.setAttribute("aria-expanded", "false");
      menuToggle.setAttribute("aria-label", menuToggle.getAttribute("data-open-label") || "Open menu");
    }
    if (menuToggle && mobileMenu) {
      menuToggle.addEventListener("click", function () {
        var open = mobileMenu.hidden;
        mobileMenu.hidden = !open;
        menuToggle.setAttribute("aria-expanded", String(open));
        menuToggle.setAttribute("aria-label", open
          ? (menuToggle.getAttribute("data-close-label") || "Close menu")
          : (menuToggle.getAttribute("data-open-label") || "Open menu"));
      });
      mobileMenu.querySelectorAll("a").forEach(function (link) {
        link.addEventListener("click", closeMenu);
      });
    }

    document.querySelectorAll("[data-faq]").forEach(function (button) {
      button.addEventListener("click", function () {
        var answer = button.parentElement && button.parentElement.querySelector(".faq-answer-wrap");
        var icon = button.querySelector(".faq-icon");
        var open = button.getAttribute("aria-expanded") === "true";
        button.setAttribute("aria-expanded", String(!open));
        if (answer) answer.classList.toggle("open", !open);
        if (icon) {
          icon.classList.toggle("open", !open);
          icon.textContent = !open ? "✓" : "⌄";
        }
      });
    });

    function setCartButtonLabel(button, label) {
      var labelElement = button.querySelector("[data-cart-button-label]");
      if (labelElement) {
        labelElement.textContent = label;
      } else {
        button.textContent = label;
      }
    }

    function updateCartCount(count) {
      if (typeof count !== "number") return;
      document.querySelectorAll(".cart-count").forEach(function (element) {
        element.textContent = String(count);
      });
    }

    function showCartFeedback(form, message, isError, showCartLink) {
      var feedback = form.querySelector("[data-cart-feedback]");
      var feedbackText = feedback && feedback.querySelector("[data-cart-feedback-text]");
      var feedbackLink = feedback && feedback.querySelector("[data-cart-feedback-link]");
      if (!feedback || !feedbackText) return;
      feedbackText.textContent = message;
      feedback.hidden = false;
      feedback.classList.toggle("is-error", Boolean(isError));
      feedback.classList.toggle("is-success", !isError);
      if (feedbackLink) feedbackLink.hidden = !showCartLink;
    }

    document.querySelectorAll(".cart-add-form").forEach(function (form) {
      form.addEventListener("submit", function (event) {
        var button = event.submitter || form.querySelector("[data-cart-add-button]");
        if (!button || button.name !== "add" || button.disabled) return;

        event.preventDefault();
        var label = button.querySelector("[data-cart-button-label]");
        var defaultLabel = button.getAttribute("data-default-label") || (label && label.textContent) || "";
        var addingLabel = button.getAttribute("data-adding-label") || "Adding…";
        var successLabel = button.getAttribute("data-success-label") || "Added";
        var errorLabel = button.getAttribute("data-error-label") || "Unable to add item.";

        button.disabled = true;
        button.setAttribute("aria-busy", "true");
        setCartButtonLabel(button, addingLabel);
        var existingFeedback = form.querySelector("[data-cart-feedback]");
        if (existingFeedback) existingFeedback.hidden = true;

        fetch(button.getAttribute("data-cart-add-url") || form.action, {
          method: "POST",
          headers: { "Accept": "application/json" },
          body: new FormData(form)
        })
          .then(function (response) {
            return response.json().catch(function () { return null; }).then(function (data) {
              if (!response.ok) {
                var responseError = new Error(errorLabel);
                responseError.nativeFallback = response.status === 404 || response.status === 405 || response.status === 415;
                throw responseError;
              }
              if (data && (data.status >= 400 || data.errors)) throw new Error(errorLabel);
              return data;
            });
          })
          .then(function () {
            var cartUrl = button.getAttribute("data-cart-json-url");
            if (!cartUrl) return null;
            return fetch(cartUrl, { headers: { "Accept": "application/json" } })
              .then(function (response) { return response.ok ? response.json() : null; })
              .catch(function () { return null; });
          })
          .then(function (cart) {
            if (cart) updateCartCount(cart.item_count);
            button.classList.add("is-added");
            setCartButtonLabel(button, successLabel);
            showCartFeedback(form, successLabel, false, true);
            window.setTimeout(function () {
              if (!button.isConnected) return;
              button.disabled = false;
              button.removeAttribute("aria-busy");
              button.classList.remove("is-added");
              setCartButtonLabel(button, defaultLabel);
            }, 2600);
          })
          .catch(function (error) {
            if (error && (error.nativeFallback || error.name === "TypeError")) {
              HTMLFormElement.prototype.submit.call(form);
              return;
            }
            button.disabled = false;
            button.removeAttribute("aria-busy");
            button.classList.remove("is-added");
            setCartButtonLabel(button, defaultLabel);
            showCartFeedback(form, errorLabel, true, false);
          });
      });
    });

    document.querySelectorAll("[data-quantity-decrease], [data-quantity-increase]").forEach(function (button) {
      button.addEventListener("click", function () {
        var control = button.closest(".cart-quantity-control");
        var input = control && control.querySelector("[data-cart-quantity]");
        if (!input) return;
        var current = parseInt(input.value, 10);
        if (!Number.isFinite(current)) current = 1;
        var next = button.hasAttribute("data-quantity-increase") ? current + 1 : Math.max(0, current - 1);
        input.value = String(next);
        input.dispatchEvent(new Event("change", { bubbles: true }));
      });
    });

    var cartForm = document.querySelector("[data-cart-form]");
    if (cartForm) {
      var cartUpdateTimer = null;
      var cartUpdateController = null;

      function updateCartQuantities() {
        var updateUrl = cartForm.getAttribute("data-cart-update-url");
        var feedback = cartForm.querySelector("[data-cart-update-feedback]");
        var updates = {};

        cartForm.querySelectorAll("[data-cart-quantity]").forEach(function (input) {
          updates[input.id.replace(/^Updates-/, "")] = Math.max(0, parseInt(input.value, 10) || 0);
          input.disabled = true;
        });

        if (!updateUrl) {
          HTMLFormElement.prototype.submit.call(cartForm);
          return;
        }

        if (cartUpdateController) cartUpdateController.abort();
        cartUpdateController = typeof AbortController === "function" ? new AbortController() : null;

        cartForm.setAttribute("aria-busy", "true");
        if (feedback) {
          feedback.textContent = cartForm.getAttribute("data-updating-label") || "Updating your bag…";
          feedback.hidden = false;
        }

        fetch(updateUrl, {
          method: "POST",
          headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ updates: updates }),
          signal: cartUpdateController ? cartUpdateController.signal : undefined
        })
          .then(function (response) {
            return response.json().catch(function () { return null; }).then(function (data) {
              if (!response.ok || (data && data.status >= 400)) throw new Error("Cart update failed");
              return data;
            });
          })
          .then(function (cart) {
            if (cart) updateCartCount(cart.item_count);
            window.location.reload();
          })
          .catch(function (error) {
            if (error && error.name === "AbortError") return;
            cartForm.removeAttribute("aria-busy");
            cartForm.querySelectorAll("[data-cart-quantity]").forEach(function (input) {
              input.disabled = false;
            });
            if (feedback) {
              feedback.textContent = cartForm.getAttribute("data-update-error-label") || "We couldn't update your bag. Please try again.";
              feedback.hidden = false;
            }
          });
      }

      cartForm.querySelectorAll("[data-cart-quantity]").forEach(function (input) {
        input.addEventListener("change", function () {
          window.clearTimeout(cartUpdateTimer);
          cartUpdateTimer = window.setTimeout(updateCartQuantities, 250);
        });
      });
    }

    var termsBodyOverflow = null;

    function getTermsModal() {
      return document.querySelector("[data-terms-modal]");
    }

    function closeTerms() {
      var modal = getTermsModal();
      if (modal) {
        modal.hidden = true;
        modal.setAttribute("aria-hidden", "true");
      }
      document.body.style.overflow = termsBodyOverflow !== null ? termsBodyOverflow : "";
      termsBodyOverflow = null;
      if (lastFocused && lastFocused.isConnected) lastFocused.focus();
      lastFocused = null;
    }

    function openTerms(trigger) {
      var modal = getTermsModal();
      if (!modal || !modal.hidden) return;
      lastFocused = trigger || document.activeElement;
      termsBodyOverflow = document.body.style.overflow;
      modal.hidden = false;
      modal.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";
      var close = modal.querySelector("[data-terms-close]");
      if (close) close.focus();
    }

    if (!document.documentElement.hasAttribute("data-rawdot-modal-events")) {
      document.documentElement.setAttribute("data-rawdot-modal-events", "true");
      document.addEventListener("click", function (event) {
        var target = event.target instanceof Element ? event.target : event.target.parentElement;
        if (!target) return;

        var openTrigger = target.closest("[data-terms-open]");
        if (openTrigger) {
          event.preventDefault();
          openTerms(openTrigger);
          return;
        }

        var closeTrigger = target.closest("[data-terms-close]");
        if (closeTrigger) {
          event.preventDefault();
          closeTerms();
          return;
        }

        var modal = target.closest("[data-terms-modal]");
        if (modal && target === modal) closeTerms();
      });

      document.addEventListener("keydown", function (event) {
        if (event.key === "Escape") {
          var modal = getTermsModal();
          if (modal && !modal.hidden) closeTerms();
          closeMenu();
        }
      });

      document.addEventListener("shopify:section:unload", function (event) {
        var target = event.target;
        if (target && target.querySelector && target.querySelector("[data-terms-modal]")) closeTerms();
      });

      document.addEventListener("shopify:section:load", function (event) {
        var target = event.target;
        var modal = target && target.querySelector ? target.querySelector("[data-terms-modal]") : null;
        if (modal) closeTerms();
      });
    }
  });
})();